import React from 'react'

const Loader = () => {
  return (
    <div className="custom-loader mx-auto mt-10"></div>
  )
}

export default Loader